<template>
  <div id="app">
    <router-view></router-view>
    <div>路由信息：{{ $route.fullPath }}</div>
    <img alt="Vue logo" src="./assets/img/logo.png" />
    <HelloWorld msg="德州家医" />
  </div>
</template>

<script>
import HelloWorld from "components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
  created: function() {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
